import { generatePath } from 'react-router-dom';
import { Params } from 'config/routes.types';

interface MakePathFunction {
  <T extends keyof Params>(route: T, params: Params[T]): string;
  (route: string, params?: Record<string, any>): string;
}

/**
 * Typed wrapper over generatePath with params from routes.types.ts
 */
export const makePath: MakePathFunction = (route: string, params: Record<string, any> = {}) => {
  const normalized: Record<string, string> = {};
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null) {
      normalized[key] = String(value);
    }
  });
  return generatePath(route, normalized);
};
